import { Routes, Route, Navigate } from 'react-router-dom';
import {
    DASHBOARD_ROUTE,
    USER_SPECIFIC_ROUTE,
    HOME_ROUTE,
    WORKFLOW_ROUTE,
    DEFAULT_ROUTE,
    FINDINGS_ROUTE,
    SETTINGS_SPECIFIC_ROUTE,
    INTEGRATIONS_ROUTE,
    NOT_FOUND_ROUTE,
    POLICIES_ROUTE,
    CREATE_ENGAGEMENT_ROUTE,
    CUSTOM_FINDINGS_ROUTE,
    TOOLING_COVERAGE_ROUTE,
    FINDING_SPECIFIC_ROUTE,
    TRAINING_SECURITY_TIPS_ROUTE,
    TRAINING_ANNUAL_COMPLIANCE_ROUTE,
    TRAINING_PHISHING_ROUTE,
    TRAINING_BROWSER_COACHING_ROUTE,
    ENGAGEMENT_LOGS_ROUTE,
    CUSTOM_ACTIONS_DETAIL_ROUTE,
    ANALYTICS_DASHBOARD_ROUTE,
    INVENTORY_ROUTE,
    AGENT_DETAIL_ROUTE,
} from 'Core-utils/routes';
import { VendorsIntegration } from 'Components/organisms';
import { INTEGRATIONSDATA } from './core-utils/constants/constants';
import {
    EngagementFlowPage,
    DashboardPage,
    UserDetailPage,
    NotFoundPage,
    ToolingCoveragePage,
    EngagementLogsPage,
    CustomActionExecutionsPage,
    AnalyticsDashboardPage,
    PhishingCampaignsPage,
    InventoryPage,
    AgentDetailPage,
} from 'Components/pages';
import 'Theme/scroll.scss';
import CreateEngagementPage from 'Components/pages/CreateEngagementPage';
import { CustomFindingsPage } from 'Components/pages/CustomFindingsPage';
import { AuthRole } from '@ampsec/platform-client';
import PrivateRoute from 'Core-utils/PrivateRoute';
import { useSelector } from 'react-redux';
import { RootState } from 'Rdx/store';
import { SecurityFindingsPage } from 'Components/pages/SecurityFindingsPage';
import VendorDetailsPage from 'Components/pages/VendorDetailsPage/VendorDetailsPage';
import { SettingsPage } from 'Components/pages/SettingsPage';
import { FindingDetailsPage } from 'Components/pages/FindingDetailsPage';
import { SecurityTipsPage } from 'Components/pages/SecurityTipsPage';
import { ComplianceTrainingPage } from 'Components/pages/ComplianceTrainingPage';
import { BrowserCoachingPage } from 'Components/pages/BrowserCoachingPage';

const AppRoutes = () => {
    const auth = useSelector((state: RootState) => state.auth);
    const userRole = (auth?.user?.role as unknown as AuthRole) ?? null;

    return (
        <Routes>
            <Route
                path={DASHBOARD_ROUTE}
                element={
                    <PrivateRoute
                        element={<DashboardPage />}
                        userRole={userRole}
                        allowedRoles={[AuthRole.ADMIN, AuthRole.OWNER, AuthRole.VIEWER, AuthRole.AGENT]}
                    />
                }
            />

            <Route
                path={USER_SPECIFIC_ROUTE}
                element={
                    <PrivateRoute
                        element={<UserDetailPage />}
                        userRole={userRole}
                        allowedRoles={[AuthRole.ADMIN, AuthRole.OWNER, AuthRole.VIEWER, AuthRole.AGENT]}
                    />
                }
            />
            <Route
                path={FINDINGS_ROUTE}
                element={
                    <PrivateRoute
                        element={<SecurityFindingsPage />}
                        userRole={userRole}
                        allowedRoles={[AuthRole.ADMIN, AuthRole.OWNER, AuthRole.VIEWER, AuthRole.AGENT]}
                    />
                }
            />
            <Route
                path={FINDING_SPECIFIC_ROUTE}
                element={
                    <PrivateRoute
                        element={<FindingDetailsPage />}
                        userRole={userRole}
                        allowedRoles={[AuthRole.ADMIN, AuthRole.OWNER, AuthRole.VIEWER, AuthRole.AGENT]}
                    />
                }
            />
            <Route
                path={TOOLING_COVERAGE_ROUTE}
                element={
                    <PrivateRoute
                        element={<ToolingCoveragePage />}
                        userRole={userRole}
                        allowedRoles={[AuthRole.ADMIN, AuthRole.OWNER, AuthRole.VIEWER, AuthRole.AGENT]}
                    />
                }
            />
            <Route
                path={INVENTORY_ROUTE}
                element={
                    <PrivateRoute
                        element={<InventoryPage />}
                        userRole={userRole}
                        allowedRoles={[AuthRole.ADMIN, AuthRole.OWNER, AuthRole.VIEWER, AuthRole.AGENT]}
                    />
                }
            />
            <Route
                path={CUSTOM_ACTIONS_DETAIL_ROUTE}
                element={
                    <PrivateRoute
                        element={<CustomActionExecutionsPage />}
                        userRole={userRole}
                        allowedRoles={[AuthRole.ADMIN, AuthRole.OWNER]}
                    />
                }
            />
            <Route
                path={WORKFLOW_ROUTE}
                element={
                    <PrivateRoute
                        element={<EngagementFlowPage />}
                        userRole={userRole}
                        allowedRoles={[AuthRole.ADMIN, AuthRole.OWNER]}
                    />
                }
            />
            <Route
                path={SETTINGS_SPECIFIC_ROUTE}
                element={
                    <PrivateRoute
                        element={<SettingsPage />}
                        userRole={userRole}
                        allowedRoles={[AuthRole.ADMIN, AuthRole.OWNER]}
                    />
                }
            />

            <Route
                path={POLICIES_ROUTE}
                element={
                    <PrivateRoute
                        element={<VendorsIntegration integratedData={INTEGRATIONSDATA} />}
                        userRole={userRole}
                        allowedRoles={[AuthRole.ADMIN, AuthRole.OWNER]}
                    />
                }
            />
            <Route
                path={CUSTOM_FINDINGS_ROUTE}
                element={
                    <PrivateRoute
                        element={<CustomFindingsPage />}
                        userRole={userRole}
                        allowedRoles={[AuthRole.ADMIN, AuthRole.OWNER]}
                    />
                }
            />
            <Route
                path={INTEGRATIONS_ROUTE}
                element={
                    <PrivateRoute
                        element={<VendorDetailsPage />}
                        userRole={userRole}
                        allowedRoles={[AuthRole.ADMIN, AuthRole.OWNER]}
                    />
                }
            />
            <Route
                path={CREATE_ENGAGEMENT_ROUTE}
                element={
                    <PrivateRoute
                        element={<CreateEngagementPage />}
                        userRole={userRole}
                        allowedRoles={[AuthRole.ADMIN, AuthRole.OWNER]}
                    />
                }
            />
            <Route
                path={ENGAGEMENT_LOGS_ROUTE}
                element={
                    <PrivateRoute
                        element={<EngagementLogsPage />}
                        userRole={userRole}
                        allowedRoles={[AuthRole.ADMIN, AuthRole.OWNER, AuthRole.VIEWER, AuthRole.AGENT]}
                    />
                }
            />
            <Route
                path={TRAINING_SECURITY_TIPS_ROUTE}
                element={
                    <PrivateRoute
                        element={<SecurityTipsPage />}
                        userRole={userRole}
                        allowedRoles={[AuthRole.OWNER, AuthRole.ADMIN]}
                    />
                }
            />
            <Route
                path={TRAINING_ANNUAL_COMPLIANCE_ROUTE}
                element={
                    <PrivateRoute
                        element={<ComplianceTrainingPage />}
                        userRole={userRole}
                        allowedRoles={[AuthRole.ADMIN, AuthRole.OWNER]}
                    />
                }
            />
            <Route
                path={TRAINING_PHISHING_ROUTE}
                element={
                    <PrivateRoute
                        element={<PhishingCampaignsPage />}
                        userRole={userRole}
                        allowedRoles={[AuthRole.ADMIN, AuthRole.OWNER]}
                    />
                }
            />
            <Route
                path={TRAINING_BROWSER_COACHING_ROUTE}
                element={
                    <PrivateRoute
                        element={<BrowserCoachingPage />}
                        userRole={userRole}
                        allowedRoles={[AuthRole.OWNER, AuthRole.ADMIN]}
                    />
                }
            />
            <Route
                path={ANALYTICS_DASHBOARD_ROUTE}
                element={
                    <PrivateRoute
                        element={<AnalyticsDashboardPage />}
                        userRole={userRole}
                        allowedRoles={[AuthRole.OWNER, AuthRole.ADMIN, AuthRole.VIEWER, AuthRole.AGENT]}
                    />
                }
            />
            <Route
                path={AGENT_DETAIL_ROUTE}
                element={
                    <PrivateRoute
                        element={<AgentDetailPage />}
                        userRole={userRole}
                        allowedRoles={[AuthRole.ADMIN, AuthRole.OWNER, AuthRole.VIEWER, AuthRole.AGENT]}
                    />
                }
            />
            <Route path={DEFAULT_ROUTE} element={<Navigate to={`${HOME_ROUTE}/org`} replace />} />
            <Route path={NOT_FOUND_ROUTE} element={<NotFoundPage />} />
        </Routes>
    );
};

export default AppRoutes;
